/**
 * Module-level bridge so `api()` can attach the current org id as an X-Org-Id
 * header without importing the React org-context (which itself imports `api()`).
 * The OrgProvider sets this value whenever the selected org changes.
 */
let currentOrgId: string | null = null;

export function getCurrentOrgId(): string | null {
  return currentOrgId;
}

export function setCurrentOrgId(id: string | null): void {
  currentOrgId = id;
}
